// FE-only configuration — no backend involvement. This decides which
// pooja + location + language combination gets a decorative highlight +
// icon on whichever time slots remain bookable in the inline checkout.
// It is purely presentational: it never changes which slots are actually
// available (that's still driven by BMP_BE's per-date slot restrictions);
// it only decides whether/how to visually call attention to them.
//
// Matching rules, in order — first match wins:
//   - poojaName / location / language are case-insensitive.
//   - "*" matches anything.
// Add more rules here as needed; nothing else in the app needs to change.
export const SLOT_HIGHLIGHT_RULES = [
  {
    poojaName: "Ganesh Sthapana and Visarjan Puja",
    location: "*",
    language: "*",
    icon: "/icons/ganpati.svg",
    iconAlt: "Ganpati",
  },
];

const normalize = (value) => (value || "").toString().trim().toLowerCase();

const matches = (ruleValue, actualValue) =>
  ruleValue === "*" || normalize(ruleValue) === normalize(actualValue);

// Returns the matching rule's icon (or null) for the given pooja name +
// location name + language name. Any of the three being falsy simply
// results in no match (no highlight), never an error.
export const resolveSlotHighlightIcon = (poojaName, location, language) => {
  const rule = SLOT_HIGHLIGHT_RULES.find(
    (r) => matches(r.poojaName, poojaName) && matches(r.location, location) && matches(r.language, language),
  );
  return rule?.icon || null;
};
